import { Link } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import CategoryShowcase from './components/CategoryShowcase';
import TrendingCategories from './components/TrendingCategories';
import AboutSection from './components/AboutSection';
import ArticleShowcase from './components/ArticleShowcase';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

const featureImages: Record<string, string> = {
  'Product Spreadsheets': 'https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20printed%20spreadsheet%20documents%20and%20color%20coded%20tabs%2C%20warm%20natural%20lighting%2C%20minimalist%20workspace%2C%20professional%20analytics%20vibe%2C%20soft%20beige%20background&width=400&height=300&seq=feat-spreadsheets-v2&orientation=landscape',
  'Supplier Data': 'https://readdy.ai/api/search-image?query=Professional%20warehouse%20product%20inspection%20scene%20with%20quality%20control%20checklist%2C%20warm%20industrial%20lighting%2C%20organized%20shipping%20boxes%2C%20business%20sourcing%20aesthetic%2C%20clean%20neutral%20tones&width=400&height=300&seq=feat-supplier-v2&orientation=landscape',
  'Profit Analysis': 'https://readdy.ai/api/search-image?query=Financial%20analytics%20dashboard%20on%20laptop%20screen%20with%20charts%20and%20graphs%2C%20warm%20office%20setting%2C%20modern%20workspace%2C%20business%20intelligence%20theme%2C%20soft%20cream%20and%20gold%20accents&width=400&height=300&seq=feat-profit-v2&orientation=landscape',
  'TikTok Trends': 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20viral%20product%20video%20on%20social%20media%20interface%2C%20colorful%20trending%20content%20aesthetic%2C%20modern%20digital%20marketing%20theme%2C%20warm%20lighting%2C%20creative%20composition&width=400&height=300&seq=feat-tiktok-v2&orientation=landscape',
  'Weekly Updates': 'https://readdy.ai/api/search-image?query=Calendar%20with%20marked%20dates%20and%20fresh%20product%20catalog%20on%20wooden%20desk%2C%20organized%20planning%20aesthetic%2C%20natural%20morning%20light%2C%20minimalist%20workspace%2C%20warm%20beige%20and%20cream%20tones&width=400&height=300&seq=feat-updates-v2&orientation=landscape',
  'Export Ready': 'https://readdy.ai/api/search-image?query=USB%20drive%20and%20digital%20file%20transfer%20concept%20on%20clean%20desk%2C%20modern%20data%20sharing%20theme%2C%20warm%20natural%20lighting%2C%20minimalist%20tech%20aesthetic%2C%20professional%20business%20setup&width=400&height=300&seq=feat-export-v2&orientation=landscape',
};

const articleCardImages: Record<string, string> = {
  'what-is-allchinabuyspreadsheet': 'https://readdy.ai/api/search-image?query=Curious%20person%20reading%20documentation%20at%20clean%20modern%20desk%2C%20warm%20lighting%2C%20educational%20atmosphere%2C%20minimalist%20aesthetic%2C%20soft%20cream%20and%20beige%20background%2C%20concept%20of%20learning%20and%20discovery&width=600&height=400&seq=card-what-is-v2&orientation=landscape',
  'how-to-use-allchinabuyspreadsheet': 'https://readdy.ai/api/search-image?query=Step%20by%20step%20tutorial%20on%20tablet%20screen%20with%20hands%20demonstrating%2C%20modern%20workspace%2C%20natural%20lighting%2C%20educational%20technology%20theme%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20composition&width=600&height=400&seq=card-how-to-v2&orientation=landscape',
  'winning-products-china': 'https://readdy.ai/api/search-image?query=Collection%20of%20trending%20consumer%20products%20displayed%20on%20minimalist%20shelf%2C%20warm%20natural%20light%2C%20curated%20selection%20aesthetic%2C%20modern%20retail%20concept%2C%20clean%20cream%20background%2C%20professional%20product%20photography&width=600&height=400&seq=card-winning-v2&orientation=landscape',
  'tiktok-viral-products': 'https://readdy.ai/api/search-image?query=Vibrant%20social%20media%20content%20creation%20setup%20with%20ring%20light%20and%20trending%20products%2C%20modern%20creator%20aesthetic%2C%20warm%20colorful%20lighting%2C%20digital%20marketing%20theme%2C%20creative%20atmosphere&width=600&height=400&seq=card-tiktok-v2&orientation=landscape',
  'high-margin-dropshipping-items': 'https://readdy.ai/api/search-image?query=Premium%20product%20with%20price%20tag%20and%20profit%20calculation%20notes%20on%20desk%2C%20warm%20lighting%2C%20business%20analytics%20theme%2C%20minimalist%20aesthetic%2C%20professional%20finance%20concept%2C%20clean%20cream%20background&width=600&height=400&seq=card-margin-v2&orientation=landscape',
  'alibaba-vs-spreadsheet': 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20two%20different%20workspaces%20one%20cluttered%20one%20organized%2C%20contrast%20concept%2C%20warm%20lighting%2C%20business%20decision%20theme%2C%20clean%20minimalist%20composition&width=600&height=400&seq=card-vs-v2&orientation=landscape',
  'best-sourcing-platforms': 'https://readdy.ai/api/search-image?query=Multiple%20device%20screens%20showing%20different%20ecommerce%20platforms%20on%20modern%20desk%2C%20global%20sourcing%20concept%2C%20warm%20natural%20lighting%2C%20professional%20business%20atmosphere%2C%20clean%20aesthetic&width=600&height=400&seq=card-platforms-v2&orientation=landscape',
  'how-to-start-dropshipping': 'https://readdy.ai/api/search-image?query=Bright%20optimistic%20entrepreneur%20setting%20up%20online%20store%20on%20laptop%2C%20warm%20home%20office%2C%20aspirational%20lifestyle%20photography%2C%20natural%20window%20light%2C%20modern%20minimalist%20decor%2C%20beige%20and%20cream%20interior&width=600&height=400&seq=card-start-v2&orientation=landscape',
  'product-research-guide': 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20product%20catalog%20with%20analytics%20charts%20nearby%2C%20research%20and%20discovery%20concept%2C%20warm%20lighting%2C%20professional%20analyst%20workspace%2C%20clean%20minimal%20composition&width=600&height=400&seq=card-research-v2&orientation=landscape',
};

const articleSlugs = Object.keys(articles);

export default function Home() {
  const allCategories = categories;

  return (
    <div className="min-h-screen bg-background-50">
      <HeroSection />

      {/* Value Proposition + Quick Category Links */}
      <section className="py-16 md:py-24 bg-background-100">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <h2 className="text-3xl md:text-4xl text-foreground-900 leading-tight"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              Why AllChinaBuySpreadsheet Is the Fastest Way to Find Winning Products
            </h2>
            <p className="mt-5 text-foreground-600 text-base leading-relaxed">
              AllChinaBuySpreadsheet gives you structured, updated product intelligence from China suppliers. Instead of spending hours browsing AliExpress or 1688, you get ready-to-use spreadsheets with verified winning products, supplier insights, price-vs-profit analysis, TikTok trending items, and fast dropshipping validation data.
            </p>
          </div>

          {/* Feature Cards with Images */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
            {[
              { feature: 'Product Spreadsheets', benefit: 'Save 80% research time' },
              { feature: 'Supplier Data', benefit: 'Find reliable China sources' },
              { feature: 'Profit Analysis', benefit: 'Identify high-margin products' },
              { feature: 'TikTok Trends', benefit: 'Catch viral products early' },
              { feature: 'Weekly Updates', benefit: 'Stay ahead of competitors' },
              { feature: 'Export Ready', benefit: 'CSV & Excel formats included' },
            ].map((row) => (
              <div key={row.feature} className="group rounded-2xl overflow-hidden bg-background-50 transition-all duration-300 hover:-translate-y-1">
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={featureImages[row.feature]}
                    alt={row.feature}
                    title={`${row.feature} - AllChinaBuySpreadsheet`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-accent-500 flex-shrink-0"></div>
                    <p className="text-foreground-800 text-sm font-semibold">{row.feature}</p>
                  </div>
                  <p className="text-foreground-500 text-xs mt-2 ml-5">{row.benefit}</p>
                </div>
              </div>
            ))}
          </div>

          {/* All Category Buttons */}
          <div className="mt-14 text-center">
            <p className="text-foreground-500 text-sm mb-4">Browse all 14 product categories</p>
            <div className="flex flex-wrap justify-center gap-3">
              {allCategories.map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 hover:text-foreground-900 transition-all cursor-pointer whitespace-nowrap border border-background-200"
                >
                  {cat.name}
                  <i className="ri-arrow-right-up-line text-xs text-foreground-400"></i>
                </a>
              ))}
            </div>
          </div>

          <div className="mt-12 text-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Access Free Spreadsheet Library
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>

      <CategoryShowcase />
      <TrendingCategories />
      <AboutSection />

      {/* 9 SEO Articles Grid */}
      <section className="py-16 md:py-24 bg-background-50">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="text-center mb-14">
            <span className="text-foreground-400 text-xs tracking-wider uppercase">SEO Resources</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-foreground-900 mt-3"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              AllChinaBuySpreadsheet Guides &amp; Resources
            </h2>
            <p className="mt-4 text-foreground-500 text-sm max-w-xl mx-auto">
              In-depth articles to help you master product sourcing, dropshipping strategies, and spreadsheet-based research
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {articleSlugs.map((slug) => {
              const article = articles[slug];
              if (!article) return null;
              return (
                <Link
                  key={slug}
                  to={`/${slug}`}
                  className="group rounded-2xl overflow-hidden bg-background-100 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                >
                  <div className="aspect-[3/2] overflow-hidden">
                    <img
                      src={articleCardImages[slug]}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-5">
                    <span className="text-xs text-accent-700 font-medium bg-accent-100 px-2.5 py-1 rounded-full">SEO Guide</span>
                    <h3 className="text-foreground-900 font-semibold text-base mt-3 leading-snug line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-foreground-500 text-xs mt-2 line-clamp-2">{article.subtitle}</p>
                    <div className="mt-4 flex items-center gap-2 text-primary-500 text-sm font-medium">
                      Read Article
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <ArticleShowcase />

      {/* Trust / Disclosure */}
      <section className="py-12 bg-background-100">
        <div className="max-w-[1400px] mx-auto px-6 text-center">
          <div className="flex flex-wrap items-center justify-center gap-6 text-xs text-foreground-400">
            <span className="flex items-center gap-1.5">
              <i className="ri-information-line"></i>
              No product is directly sold
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-book-open-line"></i>
              Educational &amp; research purpose only
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-file-text-line"></i>
              Affiliate disclosure included
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-refresh-line"></i>
              Data updated regularly but not guaranteed
            </span>
          </div>
        </div>
      </section>

      {/* Structured Data - BreadcrumbList + WebSite */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'AllChinaBuySpreadsheet',
                item: 'https://allchinabuyspreadsheet.wtf',
              },
            ],
          }),
        }}
      />
    </div>
  );
}